export const ARCTIC = "ARCTIC";
export const ACTIVE_LISTING_IMAGES = "ACTIVE_LISTING_IMAGES";
export const CUSTOM_HERO_IMAGE = "CUSTOM_HERO_IMAGE";
export const GREY_BACKGROUND = "GREY_BACKGROUND";
export const CUSTOM_IMAGE = "CUSTOM_IMAGE";
export const OFFICE_AREA_IMAGE = "OFFICE_AREA_IMAGE";
export const ONYX = "ONYX";
export const NAVY = "NAVY";
export const LAST6MONTHS = "Last 6 months";
export const LASTYEAR = "Last year";
export const PHOTO_BACKGROUND = "PHOTO_BACKGROUND";
export const SOLD_LISTING_IMAGES = "SOLD_LISTING_IMAGES";
export const WELLCOMEMAT_VIDEO = "WELLCOMEMAT_VIDEO";

export const SEARCH_TYPES = {
  RENTALS: "rentals",
  SALES: "sales",
  SEARCH: "search",
};

export const INDEX_TYPES = {
  RENTAL: "rental",
  SALE: "sale",
};

export const INDEX_ALIASES = {
  LISTING: "sh_listing_alias",
  LOCATION: "sh_location_alias",
};

export const IMAGE_SIZES = {
  FULLSCREEN_PORTRAIT: "900x1200",
  FULLSCREEN_LANDSCAPE: "1800x1200",
  LIST_PORTRAIT: "400x534",
  LIST_PORTRAIT_330: "247x330",
  LIST_PORTRAIT_400: "300x400",
  LIST_LANDSCAPE: "801x534",
  LIST_LANDSCAPE_330: "495x330",
  LIST_LANDSCAPE_400: "600x400",
  SHOWCASE_PORTRAIT: "524x700",
  SHOWCASE_LANDSCAPE: "1050x700",
};

export const IMAGE_ORIENTATION = {
  LANDSCAPE: "landscape",
};

export const LISTING_TYPES = {
  RENTAL: "rental",
  SALE: "sale",
};

export const BRIGHTCOVE = {
  ACCOUNT_ID: "5782886755001",
  SIR_VIDEO_PLAYER: "rJlOfaQNgQ_default",
  BACKGROUND_PLAYER: "rk4ZBYpkQ_v3FrC68CLM",
};

export const REGION_URL_PARTS = {
  LA: "Los-Angeles-Real-Estate",
  PASADENA: "Pasadena-Real-Estate",
  SONOMA: "Sonoma-Real-Estate",
  SAN_FRAN: "San-Francisco-Real-Estate",
};

//office select sale
export const USER_MANAGER = "Manager";

export const ANALYTICS = {
  GA4: "ReactGa4",
  GA: "ReactGa",
};

//inappropriate words

export const INAPPROPRITATEWORDS = [
  "ass",
  "asshole",
  "bastard",
  "bitch",
  "cock",
  "cocksucker",
  "cunt",
  "dick",
  "dickhead",
  "dyke",
  "fuck",
  "motherfucker",
  "piss",
  "prick",
  "pussy",
  "shit",
  "slut",
  "whore",
  "twat",
  "wanker",
];

export const CUSTOMTRACKERPROD = "G-WC37DV73H2";
export const CUSTOMTRACKERSTAGE = "G-L2VQD26WQF";

export const AGENTSTRACKER = "agentsTracker";
export const INHOUSETRACKER = "inHouseTracker";



// WEBPACK FOOTER //
// ./src/constants/constants.js